<template>
  <div class="main_view">
    <div class="title">
      <p>
        <img src="../../../assets/oldKhy/zx_time.png" alt="" />
        在线考试-考生信息
      </p>
      <div class="return_button" @click="toReturn">返回</div>
    </div>
    <div class="info">
      <div class="info_left">
        <img :src="imgUrl" alt="" />
        <div class="info_box">
          <div v-for="(item, index) in infolist" :key="index">
            <img :src="item.imgUrl" alt="" />
            <p>
              <span :class="item.id == 3 ? 'lg' : ''">{{ item.title }}</span
              >：{{ item.data }}
            </p>
          </div>
        </div>
      </div>
      <div class="info_right" @click="toAnswer">开始考试</div>
    </div>
    <!-- 底部 -->
    <div class="footer">
      <div class="footer_view" v-for="(item, index) in infolist2" :key="index">
        <img :src="item.imgUrl" />
        <p>
          <span :class="item.id == 2 || item.id == 3 ? 'lg' : ''">{{
            item.title
          }}</span
          >：
          {{ item.data }}
        </p>
      </div>
      <div class="special">
        <p>
          <img src="@/assets/oldKhy/44.png" alt="" />
          注册事项：
        </p>
        <div>
          <el-input
            type="textarea"
            autosize
            v-model="text"
            :readonly="true"
            class="textarea"
          >
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ksPcApi from "@/api/examPc";
import loginvuex from "@/store/index";
import { portraitArr, infolist } from "./infodata";
export default {
  data() {
    return {
      imgUrl:require("@/assets/portrait/1.png"),
      infolist: [],
      infolist2: [
        {
          id: 1,
          imgUrl: require("@/assets/oldKhy/11.png"),
          title: "考试名称",
          data: "11"
        },
        {
          id: 2,
          imgUrl: require("@/assets/oldKhy/22.png"),
          title: "题量",
          data: "11"
        },
        {
          id: 3,
          imgUrl: require("@/assets/oldKhy/33.png"),
          title: "总分",
          data: "11"
        }
      ],
      text: "",
      PaperMode:'', // 组卷类型
    };
  },
  methods: {
    // 返回
    toReturn() {
      this.$router.push({
        path: "/examination/table",
        query: { type: "ks" }
      });
    },
    // 跳转答题卡界面
    toAnswer() {
      this.$router.push({
        path: "/examination/Answer",
        query: {
          examID: this.$route.query.examID,
          paperid: this.$route.query.paperid,
          paperMode:this.PaperMode
        }
      });
    },
    // 获取考生信息
    async getinfoData() {
      let obj = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
        examID: this.$route.query.examID
      };
      const { data } = await ksPcApi.examInfo(obj);
      if (data.Status == 200) {
        this.infolist[0].data = data.Data[0].UserName;
        this.infolist[1].data = data.Data[0].RealName;
        this.infolist[2].data = data.Data[0].DepartmentName;
        this.infolist[3].data = data.Data[0].PTitle;
        this.infolist2[0].data = data.Data[0].PaperTitle;
        this.infolist2[1].data = data.Data[0].TestCount + "题";
        this.infolist2[2].data = data.Data[0].TotalScore + "分";
        this.text = data.Data[0].Attention;
        this.PaperMode = data.Data[0].PaperMode
        // 头像处理
        if (data.Data[0].photoID != null) {
          portraitArr.map(item => {
            if (data.Data[0].photoID == item.photoID) {
              this.imgUrl = require(`@/assets/portrait/${data.Data[0].photoID}.png`);
            }
          });
        }
      } else {
        this.$message.error(data.Msg);
      }
    }
  },
  created() {
    this.infolist = infolist;
    this.getinfoData();
  }
};
</script>

<style lang="scss" scoped>
.main_view {
  border: 1px solid #e4e4e4;
  width: 1000px;
  margin: 0 auto;
  .title {
    padding: 8px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e4e4e4;
    align-items: center;
    p {
      display: flex;
      align-items: center;
      padding: 0px 12px;
      height: 40px;
      line-height: 40px;
      img {
        width: 24px;
        height: 24px;
        margin-right: 6px;
      }
    }
    .return_button {
      width: 70px;
      height: 30px;
      border-radius: 24px;
      background: #28a9e2;
      color: #fff;
      line-height: 30px;
      font-size: 14px;
      text-align: center;
      cursor: pointer;
    }
  }
  .info {
    height: 210px;
    display: flex;
    justify-content: space-between;
    position: relative;
    .info_left {
      display: flex;
      padding: 36px;
      img {
        width: 120px;
        height: 120px;
      }
      .info_box {
        > div {
          display: flex;
          margin-bottom: 16px;
          margin-left: 60px;
          img {
            width: 26px;
            height: 26px;
            margin-right: 8px;
          }
        }
      }
    }
    .info_right {
      width: 150px;
      height: 40px;
      text-align: center;
      background: #28a9e2;
      color: #fff;
      line-height: 40px;
      position: absolute;
      bottom: 40px;
      right: 30px;
      cursor: pointer;
    }
  }
  .footer {
    border: 1px solid #e4e4e4;
    margin: 24px 12px;
    .footer_view {
      display: flex;
      align-items: center;
      padding: 0px 24px;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #e4e4e4;
      img {
        width: 24px;
        height: 24px;
        margin-right: 18px;
      }
    }
  }
}
.lg {
  letter-spacing: 15px;
}
.special {
  height: 310px !important;
  margin: 24px;
  p {
    text-align: left;
    display: flex;
    align-items: center;
    img {
      margin-right: 18px;
    }
  }
  > div {
    margin-left: 100px;
    margin-top: 48px;
  }
}
::v-deep .el-textarea__inner{
  width: 800px;
  height: 208px;
  resize: none;
  border: none !important;
}
</style>
